import CodingEntityDropdown from 'app/pages/overview/tabs/transactions/CodingEntityDropdown';
import { AgaveDepartment, AgaveProject } from 'API';
import { selectAgaveSlice } from 'app/pages/store/agaveSlice';
import { useAppSelector } from 'app/store';
import { selectUserCompanies } from 'app/store/userCompaniesSlice';
import { supportsCodeSort } from 'util/codingSortSetting';

interface AgaveDepartmentsDropdownProps {
  disabled?: boolean;
  disableHeader?: boolean;
  selectedDepartment?: AgaveDepartment | null;
  selectedProject?: AgaveProject | null;
  onValueChange: (option: AgaveDepartment | null) => void;
  placeholder?: string;
  enabled?: boolean;
  /** Load options only when dropdown opens (use in table rows to avoid stale shared state). */
  fetchOnlyOnOpen?: boolean;
}

const AgaveDepartmentsDropdown = ({
  disabled,
  disableHeader = true,
  selectedDepartment,
  selectedProject,
  onValueChange,
  placeholder,
  enabled = true,
  fetchOnlyOnOpen,
}: AgaveDepartmentsDropdownProps) => {
  // SEE-1622: label departments with their ERP code wherever code sorting is
  // supported — same gate as vendors; without it the label repeats the name
  // ("Consulting - (Consulting)") and code order reads as random.
  const { selectedPaidol } = useAppSelector(selectUserCompanies);
  const { agaveAccount } = useAppSelector(selectAgaveSlice);
  const showCode = supportsCodeSort(selectedPaidol, agaveAccount?.source_system?.slug);

  return (
    <CodingEntityDropdown<AgaveDepartment>
      entityType="departments"
      selectedItem={selectedDepartment}
      projectId={selectedProject?.id}
      onValueChange={onValueChange}
      disabled={disabled}
      disableHeader={disableHeader}
      placeholder={placeholder}
      identifierField={showCode ? 'code' : 'name'}
      enabled={enabled}
      fetchOnlyOnOpen={fetchOnlyOnOpen}
    />
  );
};

export default AgaveDepartmentsDropdown;
